(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3ca9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3ca9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6CEO3", function(module, exports) {

$parcel$export(module.exports, "numberInput", () => $4d25f1fb5b40d443$export$f9673d71791176c6);
$parcel$export(module.exports, "emailInput", () => $4d25f1fb5b40d443$export$19732eed08316548);
$parcel$export(module.exports, "form", () => $4d25f1fb5b40d443$export$6210fa4921d2a466);
$parcel$export(module.exports, "submitBtn", () => $4d25f1fb5b40d443$export$caa0e4de22a8f00f);
$parcel$export(module.exports, "submitForm", () => $4d25f1fb5b40d443$export$e02251cfbe407ee6);
/**
 * Variables
 */ const $4d25f1fb5b40d443$export$f9673d71791176c6 = document.getElementById("restockNumber") || false;
const $4d25f1fb5b40d443$export$19732eed08316548 = document.getElementById("restockEmail") || false;
const $4d25f1fb5b40d443$export$6210fa4921d2a466 = document.getElementById("restockForm") || false;
const $4d25f1fb5b40d443$export$caa0e4de22a8f00f = $4d25f1fb5b40d443$export$6210fa4921d2a466 ? $4d25f1fb5b40d443$export$6210fa4921d2a466.querySelector('button[type="submit"]') : false;
const $4d25f1fb5b40d443$export$4adc704b839be9b2 = $4d25f1fb5b40d443$export$6210fa4921d2a466 ? $4d25f1fb5b40d443$export$6210fa4921d2a466.querySelector('input[name="productId"]').value : false;
async function $4d25f1fb5b40d443$export$e02251cfbe407ee6(email) {
    const formData = new FormData();
    formData.append("restockEmail", email);
    formData.append("productId", $4d25f1fb5b40d443$export$4adc704b839be9b2);
    formData.append("action", "handle_restock_submission");
    const response = await fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        body: formData
    });
    if (!response.ok) return false;
    const responseData = await response.json();
    return responseData;
}

});

/**
 *
 * Gets the html for a spinner
 * @deprecated Please use the Spinner class
 *
 * @param {string} color
 * @param {string} size
 * @returns {Element} The spinner
 */ function $1ad519e892694edd$export$641374ffb95bc399(color = "primary", size = "sm") {
    return new $1ad519e892694edd$export$7f7cbe89f1eacd2(color, size);
}
class $1ad519e892694edd$export$7f7cbe89f1eacd2 {
    constructor(color = "primary", size = "sm"){
        this.color = color;
        this.size = size;
        this.spinner = this.createSpinner();
        return this.spinner;
    }
    /**
     * Generates a spinner
     *
     * @returns {mixed} The spinner
     */ createSpinner() {
        const spinner = document.createElement("span");
        spinner.innerHTML = `<div role="status" class="spinner-border spinner-border-${this.size} text-${this.color}"></div>`;
        return spinner;
    }
    /**
     * Alters the spinner to a success icon
     *
     * @param {Element} spinner
     */ static animationSuccess(spinner, successAction = false) {
        const checkIcon = document.createElement("i");
        checkIcon.classList.add("fa-solid", "fa-check", "pop-lg");
        if (successAction) spinner.addEventListener("animationend", successAction);
        spinner.innerHTML = checkIcon.outerHTML;
    }
}
window.spinner = function(color, size) {
    return new $1ad519e892694edd$export$7f7cbe89f1eacd2(color, size);
};



var $6CEO3 = parcelRequire("6CEO3");
(async ()=>{
    if (!(0, $6CEO3.numberInput) || !(0, $6CEO3.emailInput) || !(0, $6CEO3.form)) return;
    (0, $6CEO3.emailInput).addEventListener("input", ()=>{
        (0, $6CEO3.numberInput).required = false;
    }, {
        once: true
    });
    (0, $6CEO3.form).addEventListener("submit", async (e)=>{
        e.preventDefault();
        if ((0, $6CEO3.numberInput).value) return;
        await $6acab08fb7e455a1$var$handleFormSubmission(restockEmail.value);
    });
})();
/**
 * Defines the steps to take after a user submits the form
 *
 * @param {string} email
 */ async function $6acab08fb7e455a1$var$handleFormSubmission(email) {
    const formInner = (0, $6CEO3.form).querySelector(".form-inner");
    const spinner = new (0, $1ad519e892694edd$export$7f7cbe89f1eacd2)("white");
    (0, $6CEO3.submitBtn).disabled = true;
    (0, $6CEO3.submitBtn).innerHTML += `<span class="ms-2">${spinner.outerHTML}</span>`;
    const alertEl = document.createElement("div");
    alertEl.classList.add("alert", "fade");
    alertEl.role = "alert";
    (0, $6CEO3.form).append(alertEl);
    let message = "Er is iets mis gegaan";
    try {
        const response = await (0, $6CEO3.submitForm)(email);
        const success = response.success || false;
        if (response.data) message = response.data;
        if (!success) throw new Error("An error occurred while submitting your data. Please contact a developer.");
        alertEl.innerHTML = message;
        alertEl.classList.add("alert-success");
    } catch (err) {
        console.error(err);
        alertEl.classList.add("alert-danger");
        alertEl.innerHTML = message;
    } finally{
        formInner.remove();
        alertEl.classList.add("show");
    }
}

})();
//# sourceMappingURL=loveli-restock.js.map
